<af-main-container [title]="'i18n_af_notifications' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false">
    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab class="text-center h-100">
                <ng-template matTabLabel>
          <span fxLayout="row" class="t2-semi-bold c-primary-gray-900"
                [innerHTML]="(tab ==='tabUnreadNotifications' && notificationsCount
                     ? 'i18n_af_tabUnreadNotificationsWithCount'
                     : 'i18n_af_' + tab) | translate : {
                     count: notificationsCount,
                     class: 'ml-4 c-primary-green-800'
                     }">
          </span>
                </ng-template>
                <ng-template matTabContent>
                    <af-notification class="w-100 h-100"
                                     (notificationChangesListener)="loadNotifications($event)"
                                     (loadMoreListener)="loadMoreUnread()"
                                     [infiniteScroll]="tab === 'tabUnreadNotifications'"
                                     [markOnVisible]="tab === 'tabUnreadNotifications'"
                                     [hasMore]="(tabNotificationHolder[tab]?.response?.nextBeforeId ?? null) !== null"
                                     [filterFields]="filterFields"
                                     [notifications]="tabNotificationHolder[tab]?.response?.items || []"
                                     [totalElements]="tabNotificationHolder[tab]?.response?.total"
                                     [filterEvent]="tabNotificationHolder[tab]?.notificationEvent.filter"
                                     [pageEvent]="tabNotificationHolder[tab]?.notificationEvent.page"/>
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
